import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";

import Home from "./Pages/Home/Home";
import Orders from "./Pages/Orders/Orders";
import AddOrder from "./Pages/AddOrder/AddOrder";
import Sidebar from "./Components/Sidebar/Sidebar";
import TopBar from "./Components/TopBar/TopBar";
import Products from "./Pages/Products/Products";
import Analytics from "./Pages/Analytics/Analytics";
import { AddProduct } from "./Pages/AddProduct/AddProduct";
import { AddDesign } from "./Pages/AddDesign/AddDesign";
import { AddCategory } from "./Pages/AddCategory.js/AddCategory";
import { AddTheme } from "./Pages/AddTheme/AddTheme";
import { Login } from "./Pages/Login/Login";
import { Designs } from "./Pages/Designs/Designs";
import Unauthorized from "./Pages/Unauthorized/Unauthorized";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import { AddWorker } from "./Pages/AddWorker/AddWorker";
import Workers from "./Pages/Workers/Workers";
import { Profile } from "./Pages/Profile/Profile";
import { EditProduct } from "./Pages/EditProduct/EditProduct";
import { EditDesign } from "./Pages/EditDesign/EditDesign";
import { AddClient } from "./Pages/AddClient/AddClient";
import Clients from "./Pages/Clients/Clients";
import ClientDetail from "./Pages/ClientDetail/ClientDetail";
import Roles from "./Pages/Roles/Roles";
import Sessions from "./Pages/Sessions/Sessions";
import AuditLog from "./Pages/AuditLog/AuditLog";
import Stock from "./Pages/Stock/Stock";
import StockMovements from "./Pages/StockMovements/StockMovements";
import StockAlerts from "./Pages/StockAlerts/StockAlerts";
import RawMaterials from "./Pages/RawMaterials/RawMaterials";
import RawMaterialMovements from "./Pages/RawMaterialMovements/RawMaterialMovements";
import ProductionOrders from "./Pages/ProductionOrders/ProductionOrders";
import ProductionStepLogs from "./Pages/ProductionStepLogs/ProductionStepLogs";
import ProductionOrderDetail from "./Pages/ProductionOrderDetail/ProductionOrderDetail";
import ProductionTracking from "./Pages/ProductionTracking/ProductionTracking";
import { ForgotPassword } from "./Pages/ForgotPassword/ForgotPassword";
import { ResetPassword } from "./Pages/ResetPassword/ResetPassword";

const AppContent = () => {
  const location = useLocation();
  const currentUser = useSelector((state) => state.auth.currentUser);

  const isLoginPage = location.pathname === "/login";
  const shouldShowSidebar = currentUser && !isLoginPage;

  return (
    <div className="App">
      <div className={shouldShowSidebar ? "AppGlass" : "AppGlass no-sidebar"}>
        {shouldShowSidebar && <Sidebar />}

        <div className="content-wrapper">
          {shouldShowSidebar && <TopBar />}
          <main className="content-main">
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-order"
            element={
              <ProtectedRoute>
                <AddOrder />
              </ProtectedRoute>
            }
          />

          <Route
            path="/products/"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />

          <Route
            path="/products/:product_id"
            element={
              <ProtectedRoute>
                <EditProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="/designs"
            element={
              <ProtectedRoute>
                <Designs />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <ProtectedRoute adminOnly={true}>
                <Analytics />
              </ProtectedRoute>
            }
          />

          <Route
            path="/designs/edit/:id"
            element={
              <ProtectedRoute>
                <EditDesign />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-product"
            element={
              <ProtectedRoute permission="products:create">
                <AddProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-design/:product_id?"
            element={
              <ProtectedRoute permission="designs:create">
                <AddDesign />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-category"
            element={
              <ProtectedRoute permission="categories:create">
                <AddCategory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-theme"
            element={
              <ProtectedRoute permission="themes:create">
                <AddTheme />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-user"
            element={
              <ProtectedRoute permission="workers:create">
                <AddWorker />
              </ProtectedRoute>
            }
          />

          <Route
            path="/workers"
            element={
              <ProtectedRoute permission="workers:read">
                <Workers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients"
            element={
              <ProtectedRoute permission="clients:read">
                <Clients />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients/:id"
            element={
              <ProtectedRoute permission="clients:read">
                <ClientDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-client"
            element={
              <ProtectedRoute permission="clients:create">
                <AddClient />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients/:id"
            element={
              <ProtectedRoute>
                <ClientDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/roles"
            element={
              <ProtectedRoute permission="roles:read">
                <Roles />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sessions"
            element={
              <ProtectedRoute permission="sessions:read">
                <Sessions />
              </ProtectedRoute>
            }
          />

          <Route
            path="/audit-log"
            element={
              <ProtectedRoute permission="auditlogs:read">
                <AuditLog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock"
            element={
              <ProtectedRoute permission="stock:read">
                <Stock />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock/movements"
            element={
              <ProtectedRoute permission="stock:read">
                <StockMovements />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock/alerts"
            element={
              <ProtectedRoute permission="stock:read">
                <StockAlerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/raw-materials"
            element={
              <ProtectedRoute permission="production:read">
                <RawMaterials />
              </ProtectedRoute>
            }
          />
          <Route
            path="/raw-materials/movements"
            element={
              <ProtectedRoute permission="production:read">
                <RawMaterialMovements />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production-orders"
            element={
              <ProtectedRoute permission="production:read">
                <ProductionOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production-orders/step-logs"
            element={
              <ProtectedRoute permission="production:read">
                <ProductionStepLogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production-orders/tracking"
            element={
              <ProtectedRoute permission="production:read">
                <ProductionTracking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production-orders/:id"
            element={
              <ProtectedRoute permission="production:read">
                <ProductionOrderDetail />
              </ProtectedRoute>
            }
          />

          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;